import React from "react";
import { Ship, Plane, FileText } from "lucide-react";

import HflDashboard from "./HflDashboard";
import MblDashboard from "./MblDashboard";
import { ControlTowerPage } from "./oceanDashboardUi";
import { TRANSPORT_MODES } from "./transportModes";

// Ocean ve Air aynı sayfa yapısını kullanır; mode ile veri kaynağı ve etiketler değişir
function OceanDashboard({ embedded = false, mode = "ocean" }) {
    const cfg = TRANSPORT_MODES[mode];

    return (
        <ControlTowerPage
            embedded={embedded}
            title={cfg.title}
            subtitle="Active shipments, operational risks and file performance in one view."
            tabs={[
                { label: cfg.hflLabel, icon: FileText, component: <HflDashboard mode={mode} /> },
                { label: cfg.mblLabel, icon: mode === "air" ? Plane : Ship, component: <MblDashboard mode={mode} /> },
            ]}
        />
    );
}

export default OceanDashboard;
